module.exports = __webpack_public_path__ + "media/recupel4.73b78707.mp4";